var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.5 0.819702H0.5V3.8197H3.5V0.819702ZM8.75 0.819702H5.75V3.8197H8.75V0.819702ZM0.5 6.0697H3.5V9.0697H0.5V6.0697ZM8.75 6.0697H5.75V9.0697H8.75V6.0697ZM0.5 11.3197H3.5V14.3197H0.5V11.3197ZM8.75 11.3197H5.75V14.3197H8.75V11.3197Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"9","height":"15","viewBox":"0 0 9 15","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
